import styles from './JoinSection.module.css';

export default function JoinSection() {
  return (
    <section className={styles.joinSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.sectionTitle}>Join Our Vision</h2>
          <p className={styles.sectionSubtitle}>Pioneering the future of real estate technology</p>
        </div>

        <div className={styles.contentWrapper}>
          <div className={styles.leftPanel}>
            <h3 className={styles.panelTitle}>We Seek <span>Exceptional Talent</span></h3>
            <ul className={styles.valueList}>
              <li className={styles.valueItem}>
                <div className={styles.valueIcon}>✦</div>
                <div className={styles.valueContent}>
                  <h4>Merit Over Credentials</h4>
                  <p>Your skills speak louder than degrees or resumes</p>
                </div>
              </li>
              <li className={styles.valueItem}>
                <div className={styles.valueIcon}>✦</div>
                <div className={styles.valueContent}>
                  <h4>Impact-Driven Work</h4>
                  <p>Build solutions that transform real estate experiences</p>
                </div>
              </li>
              <li className={styles.valueItem}>
                <div className={styles.valueIcon}>✦</div>
                <div className={styles.valueContent}>
                  <h4>Founder-Led Growth</h4>
                  <p>Work directly with leadership on strategic initiatives</p>
                </div>
              </li>
            </ul>
          </div>

          <div className={styles.rightPanel}>
            <div className={styles.benefitsCard}>
              <h3 className={styles.benefitsTitle}>Why Property Plateau?</h3>
              <ul className={styles.benefitsList}>
                <li className={styles.benefitItem}>
                  <span className={styles.benefitIcon}>→</span>
                  <p>Lead India's proptech revolution from the frontlines</p>
                </li>
                <li className={styles.benefitItem}>
                  <span className={styles.benefitIcon}>→</span>
                  <p>Collaborate with industry veterans and innovators</p>
                </li>
                <li className={styles.benefitItem}>
                  <span className={styles.benefitIcon}>→</span>
                  <p>Ownership in projects with real market impact</p>
                </li>
                <li className={styles.benefitItem}>
                  <span className={styles.benefitIcon}>→</span>
                  <p>Flexible environment that rewards initiative</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}